import React from "react";
import * as XLSX from "xlsx";
import exportPic from "../assets/images/export.png";

const ExportToExcel = React.forwardRef(({ fileName, type }, ref) => {
  const exportToCSV = () => {
    if (!ref.current) {
      console.error("Table reference is not defined");
      return;
    }

    const tableElement = ref.current.cloneNode(true);
    Array.from(tableElement.querySelectorAll("tr")).forEach((row) => {
      const cells = row.querySelectorAll("th, td");
      if (cells.length > 0) {
        const lastIndex = cells.length - 1;
        const thirdToLastIndex = cells.length - 3;
        const secondToLastIndex = cells.length - 2;

        row.removeChild(cells[lastIndex]);

        if (type === "course" && secondToLastIndex >= 0) {
          console.log("amit");

          row.removeChild(cells[secondToLastIndex]);
        }
      }
    });

    const worksheet = XLSX.utils.table_to_sheet(tableElement); // Convert the modified table to a sheet

    // Convert the worksheet to CSV
    const csv = XLSX.utils.sheet_to_csv(worksheet);

    // Create a blob from the CSV data
    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    const link = document.createElement("a");
    const url = URL.createObjectURL(blob);
    link.setAttribute("href", url);
    link.setAttribute("download", `${fileName}.csv`);
    link.style.visibility = "hidden";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <button
      className="ExportBtn"
      style={{
        textAlign: "center",
      }}
      onClick={exportToCSV}
    >
      <span>
        <img src={exportPic} alt="export" />
      </span>
      Export
    </button>
  );
});

export default ExportToExcel;
